import { combineReducers } from 'redux';

const users = (state = { result: [], totalCount: 0 }, action) => {
  switch (action.type) {
    case 'FETCH_EA_USERS_FULFILLED':
      return action.payload.data;
    case 'FETCH_EA_USERS_REJECTED':
      return { result: [], totalCount: 0 };
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_EA_USERS_FULFILLED':
    case 'FETCH_EA_USERS_REJECTED':
      return false;
    case 'FETCH_EA_USERS_PENDING':
      return true;
    default:
      return state;
  }
};

const externalApi = combineReducers({
  users,
  isFetching,
});

export default externalApi;
